/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import replaceElement from './replaceElement.js';
import * as iconsAndAliases from './iconsAndAliases.js';
export { iconsAndAliases as icons };
export { default as createElement } from './createElement.js';
export { default as AArrowDown } from './icons/a-arrow-down.js';
export { default as AArrowUp } from './icons/a-arrow-up.js';
export { default as ALargeSmall } from './icons/a-large-small.js';
export { default as Accessibility } from './icons/accessibility.js';
export { default as Activity } from './icons/activity.js';
export { default as AirVent } from './icons/air-vent.js';
export { default as Airplay } from './icons/airplay.js';
export { default as AlarmClockCheck } from './icons/alarm-clock-check.js';
export { default as AlarmClockMinus } from './icons/alarm-clock-minus.js';
export { default as AlarmClockOff } from './icons/alarm-clock-off.js';
export { default as AlarmClockPlus } from './icons/alarm-clock-plus.js';
export { default as AlarmClock } from './icons/alarm-clock.js';
export { default as AlarmSmoke } from './icons/alarm-smoke.js';
export { default as Album } from './icons/album.js';
export { default as AlignCenterHorizontal } from './icons/align-center-horizontal.js';
export { default as AlignCenterVertical } from './icons/align-center-vertical.js';
export { default as AlignCenter } from './icons/align-center.js';
export { default as AlignEndHorizontal } from './icons/align-end-horizontal.js';
export { default as AlignEndVertical } from './icons/align-end-vertical.js';
export { default as AlignHorizontalDistributeCenter } from './icons/align-horizontal-distribute-center.js';
export { default as AlignHorizontalDistributeEnd } from './icons/align-horizontal-distribute-end.js';
export { default as AlignHorizontalDistributeStart } from './icons/align-horizontal-distribute-start.js';
export { default as AlignHorizontalJustifyCenter } from './icons/align-horizontal-justify-center.js';
export { default as AlignHorizontalJustifyEnd } from './icons/align-horizontal-justify-end.js';
export { default as AlignHorizontalJustifyStart } from './icons/align-horizontal-justify-start.js';
export { default as AlignHorizontalSpaceAround } from './icons/align-horizontal-space-around.js';
export { default as AlignHorizontalSpaceBetween } from './icons/align-horizontal-space-between.js';
export { default as AlignJustify } from './icons/align-justify.js';
export { default as AlignLeft } from './icons/align-left.js';
export { default as AlignRight } from './icons/align-right.js';
export { default as AlignStartHorizontal } from './icons/align-start-horizontal.js';
export { default as AlignStartVertical } from './icons/align-start-vertical.js';
export { default as AlignVerticalDistributeCenter } from './icons/align-vertical-distribute-center.js';
export { default as AlignVerticalDistributeEnd } from './icons/align-vertical-distribute-end.js';
export { default as AlignVerticalDistributeStart } from './icons/align-vertical-distribute-start.js';
export { default as AlignVerticalJustifyCenter } from './icons/align-vertical-justify-center.js';
export { default as AlignVerticalJustifyEnd } from './icons/align-vertical-justify-end.js';
export { default as AlignVerticalJustifyStart } from './icons/align-vertical-justify-start.js';
export { default as AlignVerticalSpaceAround } from './icons/align-vertical-space-around.js';
export { default as AlignVerticalSpaceBetween } from './icons/align-vertical-space-between.js';
export { default as Ambulance } from './icons/ambulance.js';
export { default as Ampersand } from './icons/ampersand.js';
export { default as Ampersands } from './icons/ampersands.js';
export { default as Anchor } from './icons/anchor.js';
export { default as Angry } from './icons/angry.js';
export { default as Annoyed } from './icons/annoyed.js';
export { default as Antenna } from './icons/antenna.js';
export { default as Anvil } from './icons/anvil.js';
export { default as Aperture } from './icons/aperture.js';
export { default as AppWindowMac } from './icons/app-window-mac.js';
export { default as AppWindow } from './icons/app-window.js';
export { default as Apple } from './icons/apple.js';
export { default as ArchiveRestore } from './icons/archive-restore.js';
export { default as ArchiveX } from './icons/archive-x.js';
export { default as Archive } from './icons/archive.js';
export { default as AreaChart } from './icons/area-chart.js';
export { default as Armchair } from './icons/armchair.js';
export { default as ArrowBigDownDash } from './icons/arrow-big-down-dash.js';
export { default as ArrowBigDown } from './icons/arrow-big-down.js';
export { default as ArrowBigLeftDash } from './icons/arrow-big-left-dash.js';
export { default as ArrowBigLeft } from './icons/arrow-big-left.js';
export { default as ArrowBigRightDash } from './icons/arrow-big-right-dash.js';
export { default as ArrowBigRight } from './icons/arrow-big-right.js';
export { default as ArrowBigUpDash } from './icons/arrow-big-up-dash.js';
export { default as ArrowBigUp } from './icons/arrow-big-up.js';
export { default as ArrowDown01 } from './icons/arrow-down-0-1.js';
export { default as ArrowDown10 } from './icons/arrow-down-1-0.js';
export { default as ArrowDownAZ } from './icons/arrow-down-a-z.js';
export { default as ArrowDownFromLine } from './icons/arrow-down-from-line.js';
export { default as ArrowDownLeft } from './icons/arrow-down-left.js';
export { default as ArrowDownNarrowWide } from './icons/arrow-down-narrow-wide.js';
export { default as ArrowDownRight } from './icons/arrow-down-right.js';
export { default as ArrowDownToDot } from './icons/arrow-down-to-dot.js';
export { default as ArrowDownToLine } from './icons/arrow-down-to-line.js';
export { default as ArrowDownUp } from './icons/arrow-down-up.js';
export { default as ArrowDownWideNarrow } from './icons/arrow-down-wide-narrow.js';
export { default as ArrowDownZA } from './icons/arrow-down-z-a.js';
export { default as ArrowDown } from './icons/arrow-down.js';
export { default as ArrowLeftFromLine } from './icons/arrow-left-from-line.js';
export { default as ArrowLeftRight } from './icons/arrow-left-right.js';
export { default as ArrowLeftToLine } from './icons/arrow-left-to-line.js';
export { default as ArrowLeft } from './icons/arrow-left.js';
export { default as ArrowRightFromLine } from './icons/arrow-right-from-line.js';
export { default as ArrowRightLeft } from './icons/arrow-right-left.js';
export { default as ArrowRightToLine } from './icons/arrow-right-to-line.js';
export { default as ArrowRight } from './icons/arrow-right.js';
export { default as ArrowUp01 } from './icons/arrow-up-0-1.js';
export { default as ArrowUp10 } from './icons/arrow-up-1-0.js';
export { default as ArrowUpAZ } from './icons/arrow-up-a-z.js';
export { default as ArrowUpDown } from './icons/arrow-up-down.js';
export { default as ArrowUpFromDot } from './icons/arrow-up-from-dot.js';
export { default as ArrowUpFromLine } from './icons/arrow-up-from-line.js';
export { default as ArrowUpLeft } from './icons/arrow-up-left.js';
export { default as ArrowUpNarrowWide } from './icons/arrow-up-narrow-wide.js';
export { default as ArrowUpRight } from './icons/arrow-up-right.js';
export { default as ArrowUpToLine } from './icons/arrow-up-to-line.js';
export { default as ArrowUpWideNarrow } from './icons/arrow-up-wide-narrow.js';
export { default as ArrowUpZA } from './icons/arrow-up-z-a.js';
export { default as ArrowUp } from './icons/arrow-up.js';
export { default as ArrowsUpFromLine } from './icons/arrows-up-from-line.js';
export { default as Asterisk } from './icons/asterisk.js';
export { default as AtSign } from './icons/at-sign.js';
export { default as Atom } from './icons/atom.js';
export { default as AudioLines } from './icons/audio-lines.js';
export { default as AudioWaveform } from './icons/audio-waveform.js';
export { default as Award } from './icons/award.js';
export { default as Axe } from './icons/axe.js';
export { default as Axis3d } from './icons/axis-3d.js';
export { default as Baby } from './icons/baby.js';
export { default as Backpack } from './icons/backpack.js';
export { default as BadgeAlert } from './icons/badge-alert.js';
export { default as BadgeCent } from './icons/badge-cent.js';
export { default as BadgeCheck } from './icons/badge-check.js';
export { default as BadgeDollarSign } from './icons/badge-dollar-sign.js';
export { default as BadgeEuro } from './icons/badge-euro.js';
export { default as BadgeHelp } from './icons/badge-help.js';
export { default as BadgeIndianRupee } from './icons/badge-indian-rupee.js';
export { default as BadgeInfo } from './icons/badge-info.js';
export { default as BadgeJapaneseYen } from './icons/badge-japanese-yen.js';
export { default as BadgeMinus } from './icons/badge-minus.js';
export { default as BadgePercent } from './icons/badge-percent.js';
export { default as BadgePlus } from './icons/badge-plus.js';
export { default as BadgePoundSterling } from './icons/badge-pound-sterling.js';
export { default as BadgeRussianRuble } from './icons/badge-russian-ruble.js';
export { default as BadgeSwissFranc } from './icons/badge-swiss-franc.js';
export { default as BadgeX } from './icons/badge-x.js';
export { default as Badge } from './icons/badge.js';
export { default as BaggageClaim } from './icons/baggage-claim.js';
export { default as Ban } from './icons/ban.js';
export { default as Banana } from './icons/banana.js';
export { default as Banknote } from './icons/banknote.js';
export { default as BarChart2 } from './icons/bar-chart-2.js';
export { default as BarChart3 } from './icons/bar-chart-3.js';
export { default as BarChart4 } from './icons/bar-chart-4.js';
export { default as BarChartBig } from './icons/bar-chart-big.js';
export { default as BarChartHorizontalBig } from './icons/bar-chart-horizontal-big.js';
export { default as BarChartHorizontal } from './icons/bar-chart-horizontal.js';
export { default as BarChart } from './icons/bar-chart.js';
export { default as Barcode } from './icons/barcode.js';
export { default as Baseline } from './icons/baseline.js';
export { default as Bath } from './icons/bath.js';
export { default as BatteryCharging } from './icons/battery-charging.js';
export { default as BatteryFull } from './icons/battery-full.js';
export { default as BatteryLow } from './icons/battery-low.js';
export { default as BatteryMedium } from './icons/battery-medium.js';
export { default as BatteryWarning } from './icons/battery-warning.js';
export { default as Battery } from './icons/battery.js';
export { default as Beaker } from './icons/beaker.js';
export { default as BeanOff } from './icons/bean-off.js';
export { default as Bean } from './icons/bean.js';
export { default as BedDouble } from './icons/bed-double.js';
export { default as BedSingle } from './icons/bed-single.js';
export { default as Bed } from './icons/bed.js';
export { default as Beef } from './icons/beef.js';
export { default as Beer } from './icons/beer.js';
export { default as BellDot } from './icons/bell-dot.js';
export { default as BellElectric } from './icons/bell-electric.js';
export { default as BellMinus } from './icons/bell-minus.js';
export { default as BellOff } from './icons/bell-off.js';
export { default as BellPlus } from './icons/bell-plus.js';
export { default as BellRing } from './icons/bell-ring.js';
export { default as Bell } from './icons/bell.js';
export { default as BetweenHorizontalEnd } from './icons/between-horizontal-end.js';
export { default as BetweenHorizontalStart } from './icons/between-horizontal-start.js';
export { default as BetweenVerticalEnd } from './icons/between-vertical-end.js';
export { default as BetweenVerticalStart } from './icons/between-vertical-start.js';
export { default as Bike } from './icons/bike.js';
export { default as Binary } from './icons/binary.js';
export { default as Biohazard } from './icons/biohazard.js';
export { default as Bird } from './icons/bird.js';
export { default as Bitcoin } from './icons/bitcoin.js';
export { default as Blend } from './icons/blend.js';
export { default as Blinds } from './icons/blinds.js';
export { default as Blocks } from './icons/blocks.js';
export { default as BluetoothConnected } from './icons/bluetooth-connected.js';
export { default as BluetoothOff } from './icons/bluetooth-off.js';
export { default as BluetoothSearching } from './icons/bluetooth-searching.js';
export { default as Bluetooth } from './icons/bluetooth.js';
export { default as Bold } from './icons/bold.js';
export { default as Bolt } from './icons/bolt.js';
export { default as Bomb } from './icons/bomb.js';
export { default as Bone } from './icons/bone.js';
export { default as BookA } from './icons/book-a.js';
export { default as BookAudio } from './icons/book-audio.js';
export { default as BookCheck } from './icons/book-check.js';
export { default as BookCopy } from './icons/book-copy.js';
export { default as BookDashed } from './icons/book-dashed.js';
export { default as BookDown } from './icons/book-down.js';
export { default as BookHeadphones } from './icons/book-headphones.js';
export { default as BookHeart } from './icons/book-heart.js';
export { default as BookImage } from './icons/book-image.js';
export { default as BookKey } from './icons/book-key.js';
export { default as BookLock } from './icons/book-lock.js';
export { default as BookMarked } from './icons/book-marked.js';
export { default as BookMinus } from './icons/book-minus.js';
export { default as BookOpenCheck } from './icons/book-open-check.js';
export { default as BookOpenText } from './icons/book-open-text.js';
export { default as BookOpen } from './icons/book-open.js';
export { default as BookPlus } from './icons/book-plus.js';
export { default as BookText } from './icons/book-text.js';
export { default as BookType } from './icons/book-type.js';
export { default as BookUp2 } from './icons/book-up-2.js';
export { default as BookUp } from './icons/book-up.js';
export { default as BookUser } from './icons/book-user.js';
export { default as BookX } from './icons/book-x.js';
export { default as Book } from './icons/book.js';
export { default as BookmarkCheck } from './icons/bookmark-check.js';
export { default as BookmarkMinus } from './icons/bookmark-minus.js';
export { default as BookmarkPlus } from './icons/bookmark-plus.js';
export { default as BookmarkX } from './icons/bookmark-x.js';
export { default as Bookmark } from './icons/bookmark.js';
export { default as BoomBox } from './icons/boom-box.js';
export { default as BotMessageSquare } from './icons/bot-message-square.js';
export { default as Bot } from './icons/bot.js';
export { default as BoxSelect } from './icons/box-select.js';
export { default as Box } from './icons/box.js';
export { default as Boxes } from './icons/boxes.js';
export { default as Braces } from './icons/braces.js';
export { default as Brackets } from './icons/brackets.js';
export { default as BrainCircuit } from './icons/brain-circuit.js';
export { default as BrainCog } from './icons/brain-cog.js';
export { default as Brain } from './icons/brain.js';
export { default as BrickWall } from './icons/brick-wall.js';
export { default as BriefcaseBusiness } from './icons/briefcase-business.js';
export { default as BriefcaseMedical } from './icons/briefcase-medical.js';
export { default as Briefcase } from './icons/briefcase.js';
export { default as BringToFront } from './icons/bring-to-front.js';
export { default as Brush } from './icons/brush.js';
export { default as BugOff } from './icons/bug-off.js';
export { default as BugPlay } from './icons/bug-play.js';
export { default as Bug } from './icons/bug.js';
export { default as Building2 } from './icons/building-2.js';
export { default as Building } from './icons/building.js';
export { default as BusFront } from './icons/bus-front.js';
export { default as Bus } from './icons/bus.js';
export { default as CableCar } from './icons/cable-car.js';
export { default as Cable } from './icons/cable.js';
export { default as CakeSlice } from './icons/cake-slice.js';
export { default as Cake } from './icons/cake.js';
export { default as Calculator } from './icons/calculator.js';
export { default as CalendarCheck2 } from './icons/calendar-check-2.js';
export { default as CalendarCheck } from './icons/calendar-check.js';
export { default as CalendarClock } from './icons/calendar-clock.js';
export { default as CalendarDays } from './icons/calendar-days.js';
export { default as CalendarFold } from './icons/calendar-fold.js';
export { default as CalendarHeart } from './icons/calendar-heart.js';
export { default as CalendarMinus2 } from './icons/calendar-minus-2.js';
export { default as CalendarMinus } from './icons/calendar-minus.js';
export { default as CalendarOff } from './icons/calendar-off.js';
export { default as CalendarPlus2 } from './icons/calendar-plus-2.js';
export { default as CalendarPlus } from './icons/calendar-plus.js';
export { default as CalendarRange } from './icons/calendar-range.js';
export { default as CalendarSearch } from './icons/calendar-search.js';
export { default as CalendarX2 } from './icons/calendar-x-2.js';
export { default as CalendarX } from './icons/calendar-x.js';
export { default as Calendar } from './icons/calendar.js';
export { default as CameraOff } from './icons/camera-off.js';
export { default as Camera } from './icons/camera.js';
export { default as CandlestickChart } from './icons/candlestick-chart.js';
export { default as CandyCane } from './icons/candy-cane.js';
export { default as CandyOff } from './icons/candy-off.js';
export { default as Candy } from './icons/candy.js';
export { default as Cannabis } from './icons/cannabis.js';
export { default as CaptionsOff } from './icons/captions-off.js';
export { default as Captions } from './icons/captions.js';
export { default as CarFront } from './icons/car-front.js';
export { default as CarTaxiFront } from './icons/car-taxi-front.js';
export { default as Car } from './icons/car.js';
export { default as Caravan } from './icons/caravan.js';
export { default as Carrot } from './icons/carrot.js';
export { default as CaseLower } from './icons/case-lower.js';
export { default as CaseSensitive } from './icons/case-sensitive.js';
export { default as CaseUpper } from './icons/case-upper.js';
export { default as CassetteTape } from './icons/cassette-tape.js';
export { default as Cast } from './icons/cast.js';
export { default as Castle } from './icons/castle.js';
export { default as Cat } from './icons/cat.js';
export { default as Cctv } from './icons/cctv.js';
export { default as CheckCheck } from './icons/check-check.js';
export { default as Check } from './icons/check.js';
export { default as ChefHat } from './icons/chef-hat.js';
export { default as Cherry } from './icons/cherry.js';
export { default as ChevronDown } from './icons/chevron-down.js';
export { default as ChevronFirst } from './icons/chevron-first.js';
export { default as ChevronLast } from './icons/chevron-last.js';
export { default as ChevronLeft } from './icons/chevron-left.js';
export { default as ChevronRight } from './icons/chevron-right.js';
export { default as ChevronUp } from './icons/chevron-up.js';
export { default as ChevronsDownUp } from './icons/chevrons-down-up.js';
export { default as ChevronsDown } from './icons/chevrons-down.js';
export { default as ChevronsLeftRight } from './icons/chevrons-left-right.js';
export { default as ChevronsLeft } from './icons/chevrons-left.js';
export { default as ChevronsRightLeft } from './icons/chevrons-right-left.js';
export { default as ChevronsRight } from './icons/chevrons-right.js';
export { default as ChevronsUpDown } from './icons/chevrons-up-down.js';
export { default as ChevronsUp } from './icons/chevrons-up.js';
export { default as Chrome } from './icons/chrome.js';
export { default as Church } from './icons/church.js';
export { default as CigaretteOff } from './icons/cigarette-off.js';
export { default as Cigarette } from './icons/cigarette.js';
export { default as CircleAlert } from './icons/circle-alert.js';
export { default as CircleArrowDown } from './icons/circle-arrow-down.js';
export { default as CircleArrowLeft } from './icons/circle-arrow-left.js';
export { default as CircleArrowOutDownLeft } from './icons/circle-arrow-out-down-left.js';
export { default as CircleArrowOutDownRight } from './icons/circle-arrow-out-down-right.js';
export { default as CircleArrowOutUpLeft } from './icons/circle-arrow-out-up-left.js';
export { default as CircleArrowOutUpRight } from './icons/circle-arrow-out-up-right.js';
export { default as CircleArrowRight } from './icons/circle-arrow-right.js';
export { default as CircleArrowUp } from './icons/circle-arrow-up.js';
export { default as CircleCheckBig } from './icons/circle-check-big.js';
export { default as CircleCheck } from './icons/circle-check.js';
export { default as CircleChevronDown } from './icons/circle-chevron-down.js';
export { default as CircleChevronLeft } from './icons/circle-chevron-left.js';
export { default as CircleChevronRight } from './icons/circle-chevron-right.js';
export { default as CircleChevronUp } from './icons/circle-chevron-up.js';
export { default as CircleDashed } from './icons/circle-dashed.js';
export { default as CircleDivide } from './icons/circle-divide.js';
export { default as CircleDollarSign } from './icons/circle-dollar-sign.js';
export { default as CircleDotDashed } from './icons/circle-dot-dashed.js';
export { default as CircleDot } from './icons/circle-dot.js';
export { default as CircleEllipsis } from './icons/circle-ellipsis.js';
export { default as CircleEqual } from './icons/circle-equal.js';
export { default as CircleFadingPlus } from './icons/circle-fading-plus.js';
export { default as CircleGauge } from './icons/circle-gauge.js';
export { default as CircleHelp } from './icons/circle-help.js';
export { default as CircleMinus } from './icons/circle-minus.js';
export { default as CircleOff } from './icons/circle-off.js';
export { default as CircleParkingOff } from './icons/circle-parking-off.js';
export { default as CircleParking } from './icons/circle-parking.js';
export { default as CirclePause } from './icons/circle-pause.js';
export { default as CirclePercent } from './icons/circle-percent.js';
export { default as CirclePlay } from './icons/circle-play.js';
export { default as CirclePlus } from './icons/circle-plus.js';
export { default as CirclePower } from './icons/circle-power.js';
export { default as CircleSlash2 } from './icons/circle-slash-2.js';
export { default as CircleSlash } from './icons/circle-slash.js';
export { default as CircleStop } from './icons/circle-stop.js';
export { default as CircleUserRound } from './icons/circle-user-round.js';
export { default as CircleUser } from './icons/circle-user.js';
export { default as CircleX } from './icons/circle-x.js';
export { default as Circle } from './icons/circle.js';
export { default as CircuitBoard } from './icons/circuit-board.js';
export { default as Citrus } from './icons/citrus.js';
export { default as Clapperboard } from './icons/clapperboard.js';
export { default as ClipboardCheck } from './icons/clipboard-check.js';
export { default as ClipboardCopy } from './icons/clipboard-copy.js';
export { default as ClipboardList } from './icons/clipboard-list.js';
export { default as ClipboardMinus } from './icons/clipboard-minus.js';
export { default as ClipboardPaste } from './icons/clipboard-paste.js';
export { default as ClipboardPenLine } from './icons/clipboard-pen-line.js';
export { default as ClipboardPen } from './icons/clipboard-pen.js';
export { default as ClipboardPlus } from './icons/clipboard-plus.js';
export { default as ClipboardType } from './icons/clipboard-type.js';
export { default as ClipboardX } from './icons/clipboard-x.js';
export { default as Clipboard } from './icons/clipboard.js';
export { default as Clock1 } from './icons/clock-1.js';
export { default as Clock10 } from './icons/clock-10.js';
export { default as Clock11 } from './icons/clock-11.js';
export { default as Clock12 } from './icons/clock-12.js';
export { default as Clock2 } from './icons/clock-2.js';
export { default as Clock3 } from './icons/clock-3.js';
export { default as Clock4 } from './icons/clock-4.js';
export { default as Clock5 } from './icons/clock-5.js';
export { default as Clock6 } from './icons/clock-6.js';
export { default as Clock7 } from './icons/clock-7.js';
export { default as Clock8 } from './icons/clock-8.js';
export { default as Clock9 } from './icons/clock-9.js';
export { default as Clock } from './icons/clock.js';
export { default as CloudCog } from './icons/cloud-cog.js';
export { default as CloudDownload } from './icons/cloud-download.js';
export { default as CloudDrizzle } from './icons/cloud-drizzle.js';
export { default as CloudFog } from './icons/cloud-fog.js';
export { default as CloudHail } from './icons/cloud-hail.js';
export { default as CloudLightning } from './icons/cloud-lightning.js';
export { default as CloudMoonRain } from './icons/cloud-moon-rain.js';
export { default as CloudMoon } from './icons/cloud-moon.js';
export { default as CloudOff } from './icons/cloud-off.js';
export { default as CloudRainWind } from './icons/cloud-rain-wind.js';
export { default as CloudRain } from './icons/cloud-rain.js';
export { default as CloudSnow } from './icons/cloud-snow.js';
export { default as CloudSunRain } from './icons/cloud-sun-rain.js';
export { default as CloudSun } from './icons/cloud-sun.js';
export { default as CloudUpload } from './icons/cloud-upload.js';
export { default as Cloud } from './icons/cloud.js';
export { default as Cloudy } from './icons/cloudy.js';
export { default as Clover } from './icons/clover.js';
export { default as Club } from './icons/club.js';
export { default as CodeXml } from './icons/code-xml.js';
export { default as Code } from './icons/code.js';
export { default as Codepen } from './icons/codepen.js';
export { default as Codesandbox } from './icons/codesandbox.js';
export { default as Coffee } from './icons/coffee.js';
export { default as Cog } from './icons/cog.js';
export { default as Coins } from './icons/coins.js';
export { default as Columns2 } from './icons/columns-2.js';
export { default as Columns3 } from './icons/columns-3.js';
export { default as Columns4 } from './icons/columns-4.js';
export { default as Combine } from './icons/combine.js';
export { default as Command } from './icons/command.js';
export { default as Compass } from './icons/compass.js';
export { default as Component } from './icons/component.js';
export { default as Computer } from './icons/computer.js';
export { default as ConciergeBell } from './icons/concierge-bell.js';
export { default as Cone } from './icons/cone.js';
export { default as Construction } from './icons/construction.js';
export { default as ContactRound } from './icons/contact-round.js';
export { default as Contact } from './icons/contact.js';
export { default as Container } from './icons/container.js';
export { default as Contrast } from './icons/contrast.js';
export { default as Cookie } from './icons/cookie.js';
export { default as CookingPot } from './icons/cooking-pot.js';
export { default as CopyCheck } from './icons/copy-check.js';
export { default as CopyMinus } from './icons/copy-minus.js';
export { default as CopyPlus } from './icons/copy-plus.js';
export { default as CopySlash } from './icons/copy-slash.js';
export { default as CopyX } from './icons/copy-x.js';
export { default as Copy } from './icons/copy.js';
export { default as Copyleft } from './icons/copyleft.js';
export { default as Copyright } from './icons/copyright.js';
export { default as CornerDownLeft } from './icons/corner-down-left.js';
export { default as CornerDownRight } from './icons/corner-down-right.js';
export { default as CornerLeftDown } from './icons/corner-left-down.js';
export { default as CornerLeftUp } from './icons/corner-left-up.js';
export { default as CornerRightDown } from './icons/corner-right-down.js';
export { default as CornerRightUp } from './icons/corner-right-up.js';
export { default as CornerUpLeft } from './icons/corner-up-left.js';
export { default as CornerUpRight } from './icons/corner-up-right.js';
export { default as Cpu } from './icons/cpu.js';
export { default as CreativeCommons } from './icons/creative-commons.js';
export { default as CreditCard } from './icons/credit-card.js';
export { default as Croissant } from './icons/croissant.js';
export { default as Crop } from './icons/crop.js';
export { default as Cross } from './icons/cross.js';
export { default as Crosshair } from './icons/crosshair.js';
export { default as Crown } from './icons/crown.js';
export { default as Cuboid } from './icons/cuboid.js';
export { default as CupSoda } from './icons/cup-soda.js';
export { default as Currency } from './icons/currency.js';
export { default as Cylinder } from './icons/cylinder.js';
export { default as DatabaseBackup } from './icons/database-backup.js';
export { default as DatabaseZap } from './icons/database-zap.js';
export { default as Database } from './icons/database.js';
export { default as Delete } from './icons/delete.js';
export { default as Dessert } from './icons/dessert.js';
export { default as Diameter } from './icons/diameter.js';
export { default as DiamondPercent } from './icons/diamond-percent.js';
export { default as Diamond } from './icons/diamond.js';
export { default as Dice1 } from './icons/dice-1.js';
export { default as Dice2 } from './icons/dice-2.js';
export { default as Dice3 } from './icons/dice-3.js';
export { default as Dice4 } from './icons/dice-4.js';
export { default as Dice5 } from './icons/dice-5.js';
export { default as Dice6 } from './icons/dice-6.js';
export { default as Dices } from './icons/dices.js';
export { default as Diff } from './icons/diff.js';
export { default as Disc2 } from './icons/disc-2.js';
export { default as Disc3 } from './icons/disc-3.js';
export { default as DiscAlbum } from './icons/disc-album.js';
export { default as Disc } from './icons/disc.js';
export { default as Divide } from './icons/divide.js';
export { default as DnaOff } from './icons/dna-off.js';
export { default as Dna } from './icons/dna.js';
export { default as Dock } from './icons/dock.js';
export { default as Dog } from './icons/dog.js';
export { default as DollarSign } from './icons/dollar-sign.js';
export { default as Donut } from './icons/donut.js';
export { default as DoorClosed } from './icons/door-closed.js';
export { default as DoorOpen } from './icons/door-open.js';
export { default as Dot } from './icons/dot.js';
export { default as Download } from './icons/download.js';
export { default as DraftingCompass } from './icons/drafting-compass.js';
export { default as Drama } from './icons/drama.js';
export { default as Dribbble } from './icons/dribbble.js';
export { default as Drill } from './icons/drill.js';
export { default as Droplet } from './icons/droplet.js';
export { default as Droplets } from './icons/droplets.js';
export { default as Drum } from './icons/drum.js';
export { default as Drumstick } from './icons/drumstick.js';
export { default as Dumbbell } from './icons/dumbbell.js';
export { default as EarOff } from './icons/ear-off.js';
export { default as Ear } from './icons/ear.js';
export { default as EarthLock } from './icons/earth-lock.js';
export { default as Earth } from './icons/earth.js';
export { default as Eclipse } from './icons/eclipse.js';
export { default as EggFried } from './icons/egg-fried.js';
export { default as EggOff } from './icons/egg-off.js';
export { default as Egg } from './icons/egg.js';
export { default as EllipsisVertical } from './icons/ellipsis-vertical.js';
export { default as Ellipsis } from './icons/ellipsis.js';
export { default as EqualNot } from './icons/equal-not.js';
export { default as Equal } from './icons/equal.js';
export { default as Eraser } from './icons/eraser.js';
export { default as Euro } from './icons/euro.js';
export { default as Expand } from './icons/expand.js';
export { default as ExternalLink } from './icons/external-link.js';
export { default as EyeOff } from './icons/eye-off.js';
export { default as Eye } from './icons/eye.js';
export { default as Facebook } from './icons/facebook.js';
export { default as Factory } from './icons/factory.js';
export { default as Fan } from './icons/fan.js';
export { default as FastForward } from './icons/fast-forward.js';
export { default as Feather } from './icons/feather.js';
export { default as Fence } from './icons/fence.js';
export { default as FerrisWheel } from './icons/ferris-wheel.js';
export { default as Figma } from './icons/figma.js';
export { default as FileArchive } from './icons/file-archive.js';
export { default as FileAudio2 } from './icons/file-audio-2.js';
export { default as FileAudio } from './icons/file-audio.js';
export { default as FileAxis3d } from './icons/file-axis-3d.js';
export { default as FileBadge2 } from './icons/file-badge-2.js';
export { default as FileBadge } from './icons/file-badge.js';
export { default as FileBarChart2 } from './icons/file-bar-chart-2.js';
export { default as FileBarChart } from './icons/file-bar-chart.js';
export { default as FileBox } from './icons/file-box.js';
export { default as FileCheck2 } from './icons/file-check-2.js';
export { default as FileCheck } from './icons/file-check.js';
export { default as FileClock } from './icons/file-clock.js';
export { default as FileCode2 } from './icons/file-code-2.js';
export { default as FileCode } from './icons/file-code.js';
export { default as FileCog } from './icons/file-cog.js';
export { default as FileDiff } from './icons/file-diff.js';
export { default as FileDigit } from './icons/file-digit.js';
export { default as FileDown } from './icons/file-down.js';
export { default as FileHeart } from './icons/file-heart.js';
export { default as FileImage } from './icons/file-image.js';
export { default as FileInput } from './icons/file-input.js';
export { default as FileJson2 } from './icons/file-json-2.js';
export { default as FileJson } from './icons/file-json.js';
export { default as FileKey2 } from './icons/file-key-2.js';
export { default as FileKey } from './icons/file-key.js';
export { default as FileLineChart } from './icons/file-line-chart.js';
export { default as FileLock2 } from './icons/file-lock-2.js';
export { default as FileLock } from './icons/file-lock.js';
export { default as FileMinus2 } from './icons/file-minus-2.js';
export { default as FileMinus } from './icons/file-minus.js';
export { default as FileMusic } from './icons/file-music.js';
export { default as FileOutput } from './icons/file-output.js';
export { default as FilePenLine } from './icons/file-pen-line.js';
export { default as FilePen } from './icons/file-pen.js';
export { default as FilePieChart } from './icons/file-pie-chart.js';
export { default as FilePlus2 } from './icons/file-plus-2.js';
export { default as FilePlus } from './icons/file-plus.js';
export { default as FileQuestion } from './icons/file-question.js';
export { default as FileScan } from './icons/file-scan.js';
export { default as FileSearch2 } from './icons/file-search-2.js';
export { default as FileSearch } from './icons/file-search.js';
export { default as FileSliders } from './icons/file-sliders.js';
export { default as FileSpreadsheet } from './icons/file-spreadsheet.js';
export { default as FileStack } from './icons/file-stack.js';
export { default as FileSymlink } from './icons/file-symlink.js';
export { default as FileTerminal } from './icons/file-terminal.js';
export { default as FileText } from './icons/file-text.js';
export { default as FileType2 } from './icons/file-type-2.js';
export { default as FileType } from './icons/file-type.js';
export { default as FileUp } from './icons/file-up.js';
export { default as FileVideo2 } from './icons/file-video-2.js';
export { default as FileVideo } from './icons/file-video.js';
export { default as FileVolume2 } from './icons/file-volume-2.js';
export { default as FileVolume } from './icons/file-volume.js';
export { default as FileWarning } from './icons/file-warning.js';
export { default as FileX2 } from './icons/file-x-2.js';
export { default as FileX } from './icons/file-x.js';
export { default as File } from './icons/file.js';
export { default as Files } from './icons/files.js';
export { default as Film } from './icons/film.js';
export { default as FilterX } from './icons/filter-x.js';
export { default as Filter } from './icons/filter.js';
export { default as Fingerprint } from './icons/fingerprint.js';
export { default as FireExtinguisher } from './icons/fire-extinguisher.js';
export { default as FishOff } from './icons/fish-off.js';
export { default as FishSymbol } from './icons/fish-symbol.js';
export { default as Fish } from './icons/fish.js';
export { default as FlagOff } from './icons/flag-off.js';
export { default as FlagTriangleLeft } from './icons/flag-triangle-left.js';
export { default as FlagTriangleRight } from './icons/flag-triangle-right.js';
export { default as Flag } from './icons/flag.js';
export { default as FlameKindling } from './icons/flame-kindling.js';
export { default as Flame } from './icons/flame.js';
export { default as FlashlightOff } from './icons/flashlight-off.js';
export { default as Flashlight } from './icons/flashlight.js';
export { default as FlaskConicalOff } from './icons/flask-conical-off.js';
export { default as FlaskConical } from './icons/flask-conical.js';
export { default as FlaskRound } from './icons/flask-round.js';
export { default as FlipHorizontal2 } from './icons/flip-horizontal-2.js';
export { default as FlipHorizontal } from './icons/flip-horizontal.js';
export { default as FlipVertical2 } from './icons/flip-vertical-2.js';
export { default as FlipVertical } from './icons/flip-vertical.js';
export { default as Flower2 } from './icons/flower-2.js';
export { default as Flower } from './icons/flower.js';
export { default as Focus } from './icons/focus.js';
export { default as FoldHorizontal } from './icons/fold-horizontal.js';
export { default as FoldVertical } from './icons/fold-vertical.js';
export { default as FolderArchive } from './icons/folder-archive.js';
export { default as FolderCheck } from './icons/folder-check.js';
export { default as FolderClock } from './icons/folder-clock.js';
export { default as FolderClosed } from './icons/folder-closed.js';
export { default as FolderCog } from './icons/folder-cog.js';
export { default as FolderDot } from './icons/folder-dot.js';
export { default as FolderDown } from './icons/folder-down.js';
export { default as FolderGit2 } from './icons/folder-git-2.js';
export { default as FolderGit } from './icons/folder-git.js';
export { default as FolderHeart } from './icons/folder-heart.js';
export { default as FolderInput } from './icons/folder-input.js';
export { default as FolderKanban } from './icons/folder-kanban.js';
export { default as FolderKey } from './icons/folder-key.js';
export { default as FolderLock } from './icons/folder-lock.js';
export { default as FolderMinus } from './icons/folder-minus.js';
export { default as FolderOpenDot } from './icons/folder-open-dot.js';
export { default as FolderOpen } from './icons/folder-open.js';
export { default as FolderOutput } from './icons/folder-output.js';
export { default as FolderPen } from './icons/folder-pen.js';
export { default as FolderPlus } from './icons/folder-plus.js';
export { default as FolderRoot } from './icons/folder-root.js';
export { default as FolderSearch2 } from './icons/folder-search-2.js';
export { default as FolderSearch } from './icons/folder-search.js';
export { default as FolderSymlink } from './icons/folder-symlink.js';
export { default as FolderSync } from './icons/folder-sync.js';
export { default as FolderTree } from './icons/folder-tree.js';
export { default as FolderUp } from './icons/folder-up.js';
export { default as FolderX } from './icons/folder-x.js';
export { default as Folder } from './icons/folder.js';
export { default as Folders } from './icons/folders.js';
export { default as Footprints } from './icons/footprints.js';
export { default as Forklift } from './icons/forklift.js';
export { default as Forward } from './icons/forward.js';
export { default as Frame } from './icons/frame.js';
export { default as Framer } from './icons/framer.js';
export { default as Frown } from './icons/frown.js';
export { default as Fuel } from './icons/fuel.js';
export { default as Fullscreen } from './icons/fullscreen.js';
export { default as GalleryHorizontalEnd } from './icons/gallery-horizontal-end.js';
export { default as GalleryHorizontal } from './icons/gallery-horizontal.js';
export { default as GalleryThumbnails } from './icons/gallery-thumbnails.js';
export { default as GalleryVerticalEnd } from './icons/gallery-vertical-end.js';
export { default as GalleryVertical } from './icons/gallery-vertical.js';
export { default as Gamepad2 } from './icons/gamepad-2.js';
export { default as Gamepad } from './icons/gamepad.js';
export { default as GanttChart } from './icons/gantt-chart.js';
export { default as Gauge } from './icons/gauge.js';
export { default as Gavel } from './icons/gavel.js';
export { default as Gem } from './icons/gem.js';
export { default as Ghost } from './icons/ghost.js';
export { default as Gift } from './icons/gift.js';
export { default as GitBranchPlus } from './icons/git-branch-plus.js';
export { default as GitBranch } from './icons/git-branch.js';
export { default as GitCommitHorizontal } from './icons/git-commit-horizontal.js';
export { default as GitCommitVertical } from './icons/git-commit-vertical.js';
export { default as GitCompareArrows } from './icons/git-compare-arrows.js';
export { default as GitCompare } from './icons/git-compare.js';
export { default as GitFork } from './icons/git-fork.js';
export { default as GitGraph } from './icons/git-graph.js';
export { default as GitMerge } from './icons/git-merge.js';
export { default as GitPullRequestArrow } from './icons/git-pull-request-arrow.js';
export { default as GitPullRequestClosed } from './icons/git-pull-request-closed.js';
export { default as GitPullRequestCreateArrow } from './icons/git-pull-request-create-arrow.js';
export { default as GitPullRequestCreate } from './icons/git-pull-request-create.js';
export { default as GitPullRequestDraft } from './icons/git-pull-request-draft.js';
export { default as GitPullRequest } from './icons/git-pull-request.js';
export { default as Github } from './icons/github.js';
export { default as Gitlab } from './icons/gitlab.js';
export { default as GlassWater } from './icons/glass-water.js';
export { default as Glasses } from './icons/glasses.js';
export { default as GlobeLock } from './icons/globe-lock.js';
export { default as Globe } from './icons/globe.js';
export { default as Goal } from './icons/goal.js';
export { default as Grab } from './icons/grab.js';
export { default as GraduationCap } from './icons/graduation-cap.js';
export { default as Grape } from './icons/grape.js';
export { default as Grid2x2 } from './icons/grid-2x2.js';
export { default as Grid3x3 } from './icons/grid-3x3.js';
export { default as GripHorizontal } from './icons/grip-horizontal.js';
export { default as GripVertical } from './icons/grip-vertical.js';
export { default as Grip } from './icons/grip.js';
export { default as Group } from './icons/group.js';
export { default as Guitar } from './icons/guitar.js';
export { default as Ham } from './icons/ham.js';
export { default as Hammer } from './icons/hammer.js';
export { default as HandCoins } from './icons/hand-coins.js';
export { default as HandHeart } from './icons/hand-heart.js';
export { default as HandHelping } from './icons/hand-helping.js';
export { default as HandMetal } from './icons/hand-metal.js';
export { default as HandPlatter } from './icons/hand-platter.js';
export { default as Hand } from './icons/hand.js';
export { default as Handshake } from './icons/handshake.js';
export { default as HardDriveDownload } from './icons/hard-drive-download.js';
export { default as HardDriveUpload } from './icons/hard-drive-upload.js';
export { default as HardDrive } from './icons/hard-drive.js';
export { default as HardHat } from './icons/hard-hat.js';
export { default as Hash } from './icons/hash.js';
export { default as Haze } from './icons/haze.js';
export { default as HdmiPort } from './icons/hdmi-port.js';
export { default as Heading1 } from './icons/heading-1.js';
export { default as Heading2 } from './icons/heading-2.js';
export { default as Heading3 } from './icons/heading-3.js';
export { default as Heading4 } from './icons/heading-4.js';
export { default as Heading5 } from './icons/heading-5.js';
export { default as Heading6 } from './icons/heading-6.js';
export { default as Heading } from './icons/heading.js';
export { default as Headphones } from './icons/headphones.js';
export { default as Headset } from './icons/headset.js';
export { default as HeartCrack } from './icons/heart-crack.js';
export { default as HeartHandshake } from './icons/heart-handshake.js';
export { default as HeartOff } from './icons/heart-off.js';
export { default as HeartPulse } from './icons/heart-pulse.js';
export { default as Heart } from './icons/heart.js';
export { default as Heater } from './icons/heater.js';
export { default as Hexagon } from './icons/hexagon.js';
export { default as Highlighter } from './icons/highlighter.js';
export { default as History } from './icons/history.js';
export { default as Home } from './icons/home.js';
export { default as HopOff } from './icons/hop-off.js';
export { default as Hop } from './icons/hop.js';
export { default as Hospital } from './icons/hospital.js';
export { default as Hotel } from './icons/hotel.js';
export { default as Hourglass } from './icons/hourglass.js';
export { default as IceCreamBowl } from './icons/ice-cream-bowl.js';
export { default as IceCreamCone } from './icons/ice-cream-cone.js';
export { default as ImageDown } from './icons/image-down.js';
export { default as ImageMinus } from './icons/image-minus.js';
export { default as ImageOff } from './icons/image-off.js';
export { default as ImagePlus } from './icons/image-plus.js';
export { default as ImageUp } from './icons/image-up.js';
export { default as Image } from './icons/image.js';
export { default as Images } from './icons/images.js';
export { default as Import } from './icons/import.js';
export { default as Inbox } from './icons/inbox.js';
export { default as IndentDecrease } from './icons/indent-decrease.js';
export { default as IndentIncrease } from './icons/indent-increase.js';
export { default as IndianRupee } from './icons/indian-rupee.js';
export { default as Infinity } from './icons/infinity.js';
export { default as Info } from './icons/info.js';
export { default as InspectionPanel } from './icons/inspection-panel.js';
export { default as Instagram } from './icons/instagram.js';
export { default as Italic } from './icons/italic.js';
export { default as IterationCcw } from './icons/iteration-ccw.js';
export { default as IterationCw } from './icons/iteration-cw.js';
export { default as JapaneseYen } from './icons/japanese-yen.js';
export { default as Joystick } from './icons/joystick.js';
export { default as Kanban } from './icons/kanban.js';
export { default as KeyRound } from './icons/key-round.js';
export { default as KeySquare } from './icons/key-square.js';
export { default as Key } from './icons/key.js';
export { default as KeyboardMusic } from './icons/keyboard-music.js';
export { default as Keyboard } from './icons/keyboard.js';
export { default as LampCeiling } from './icons/lamp-ceiling.js';
export { default as LampDesk } from './icons/lamp-desk.js';
export { default as LampFloor } from './icons/lamp-floor.js';
export { default as LampWallDown } from './icons/lamp-wall-down.js';
export { default as LampWallUp } from './icons/lamp-wall-up.js';
export { default as Lamp } from './icons/lamp.js';
export { default as LandPlot } from './icons/land-plot.js';
export { default as Landmark } from './icons/landmark.js';
export { default as Languages } from './icons/languages.js';
export { default as LaptopMinimal } from './icons/laptop-minimal.js';
export { default as Laptop } from './icons/laptop.js';
export { default as LassoSelect } from './icons/lasso-select.js';
export { default as Lasso } from './icons/lasso.js';
export { default as Laugh } from './icons/laugh.js';
export { default as Layers2 } from './icons/layers-2.js';
export { default as Layers3 } from './icons/layers-3.js';
export { default as Layers } from './icons/layers.js';
export { default as LayoutDashboard } from './icons/layout-dashboard.js';
export { default as LayoutGrid } from './icons/layout-grid.js';
export { default as LayoutList } from './icons/layout-list.js';
export { default as LayoutPanelLeft } from './icons/layout-panel-left.js';
export { default as LayoutPanelTop } from './icons/layout-panel-top.js';
export { default as LayoutTemplate } from './icons/layout-template.js';
export { default as Leaf } from './icons/leaf.js';
export { default as LeafyGreen } from './icons/leafy-green.js';
export { default as LibraryBig } from './icons/library-big.js';
export { default as Library } from './icons/library.js';
export { default as LifeBuoy } from './icons/life-buoy.js';
export { default as Ligature } from './icons/ligature.js';
export { default as LightbulbOff } from './icons/lightbulb-off.js';
export { default as Lightbulb } from './icons/lightbulb.js';
export { default as LineChart } from './icons/line-chart.js';
export { default as Link2Off } from './icons/link-2-off.js';
export { default as Link2 } from './icons/link-2.js';
export { default as Link } from './icons/link.js';
export { default as Linkedin } from './icons/linkedin.js';
export { default as ListChecks } from './icons/list-checks.js';
export { default as ListCollapse } from './icons/list-collapse.js';
export { default as ListEnd } from './icons/list-end.js';
export { default as ListFilter } from './icons/list-filter.js';
export { default as ListMinus } from './icons/list-minus.js';
export { default as ListMusic } from './icons/list-music.js';
export { default as ListOrdered } from './icons/list-ordered.js';
export { default as ListPlus } from './icons/list-plus.js';
export { default as ListRestart } from './icons/list-restart.js';
export { default as ListStart } from './icons/list-start.js';
export { default as ListTodo } from './icons/list-todo.js';
export { default as ListTree } from './icons/list-tree.js';
export { default as ListVideo } from './icons/list-video.js';
export { default as ListX } from './icons/list-x.js';
export { default as List } from './icons/list.js';
export { default as LoaderCircle } from './icons/loader-circle.js';
export { default as Loader } from './icons/loader.js';
export { default as LocateFixed } from './icons/locate-fixed.js';
export { default as LocateOff } from './icons/locate-off.js';
export { default as Locate } from './icons/locate.js';
export { default as LockKeyholeOpen } from './icons/lock-keyhole-open.js';
export { default as LockKeyhole } from './icons/lock-keyhole.js';
export { default as LockOpen } from './icons/lock-open.js';
export { default as Lock } from './icons/lock.js';
export { default as LogIn } from './icons/log-in.js';
export { default as LogOut } from './icons/log-out.js';
export { default as Lollipop } from './icons/lollipop.js';
export { default as Luggage } from './icons/luggage.js';
export { default as Magnet } from './icons/magnet.js';
export { default as MailCheck } from './icons/mail-check.js';
export { default as MailMinus } from './icons/mail-minus.js';
export { default as MailOpen } from './icons/mail-open.js';
export { default as MailPlus } from './icons/mail-plus.js';
export { default as MailQuestion } from './icons/mail-question.js';
export { default as MailSearch } from './icons/mail-search.js';
export { default as MailWarning } from './icons/mail-warning.js';
export { default as MailX } from './icons/mail-x.js';
export { default as Mail } from './icons/mail.js';
export { default as Mailbox } from './icons/mailbox.js';
export { default as Mails } from './icons/mails.js';
export { default as MapPinOff } from './icons/map-pin-off.js';
export { default as MapPin } from './icons/map-pin.js';
export { default as MapPinned } from './icons/map-pinned.js';
export { default as Map } from './icons/map.js';
export { default as Martini } from './icons/martini.js';
export { default as Maximize2 } from './icons/maximize-2.js';
export { default as Maximize } from './icons/maximize.js';
export { default as Medal } from './icons/medal.js';
export { default as MegaphoneOff } from './icons/megaphone-off.js';
export { default as Megaphone } from './icons/megaphone.js';
export { default as Meh } from './icons/meh.js';
export { default as MemoryStick } from './icons/memory-stick.js';
export { default as Menu } from './icons/menu.js';
export { default as Merge } from './icons/merge.js';
export { default as MessageCircleCode } from './icons/message-circle-code.js';
export { default as MessageCircleDashed } from './icons/message-circle-dashed.js';
export { default as MessageCircleHeart } from './icons/message-circle-heart.js';
export { default as MessageCircleMore } from './icons/message-circle-more.js';
export { default as MessageCircleOff } from './icons/message-circle-off.js';
export { default as MessageCirclePlus } from './icons/message-circle-plus.js';
export { default as MessageCircleQuestion } from './icons/message-circle-question.js';
export { default as MessageCircleReply } from './icons/message-circle-reply.js';
export { default as MessageCircleWarning } from './icons/message-circle-warning.js';
export { default as MessageCircleX } from './icons/message-circle-x.js';
export { default as MessageCircle } from './icons/message-circle.js';
export { default as MessageSquareCode } from './icons/message-square-code.js';
export { default as MessageSquareDashed } from './icons/message-square-dashed.js';
export { default as MessageSquareDiff } from './icons/message-square-diff.js';
export { default as MessageSquareDot } from './icons/message-square-dot.js';
export { default as MessageSquareHeart } from './icons/message-square-heart.js';
export { default as MessageSquareMore } from './icons/message-square-more.js';
export { default as MessageSquareOff } from './icons/message-square-off.js';
export { default as MessageSquarePlus } from './icons/message-square-plus.js';
export { default as MessageSquareQuote } from './icons/message-square-quote.js';
export { default as MessageSquareReply } from './icons/message-square-reply.js';
export { default as MessageSquareShare } from './icons/message-square-share.js';
export { default as MessageSquareText } from './icons/message-square-text.js';
export { default as MessageSquareWarning } from './icons/message-square-warning.js';
export { default as MessageSquareX } from './icons/message-square-x.js';
export { default as MessageSquare } from './icons/message-square.js';
export { default as MessagesSquare } from './icons/messages-square.js';
export { default as MicOff } from './icons/mic-off.js';
export { default as MicVocal } from './icons/mic-vocal.js';
export { default as Mic } from './icons/mic.js';
export { default as Microscope } from './icons/microscope.js';
export { default as Microwave } from './icons/microwave.js';
export { default as Milestone } from './icons/milestone.js';
export { default as MilkOff } from './icons/milk-off.js';
export { default as Milk } from './icons/milk.js';
export { default as Minimize2 } from './icons/minimize-2.js';
export { default as Minimize } from './icons/minimize.js';
export { default as Minus } from './icons/minus.js';
export { default as MonitorCheck } from './icons/monitor-check.js';
export { default as MonitorDot } from './icons/monitor-dot.js';
export { default as MonitorDown } from './icons/monitor-down.js';
export { default as MonitorOff } from './icons/monitor-off.js';
export { default as MonitorPause } from './icons/monitor-pause.js';
export { default as MonitorPlay } from './icons/monitor-play.js';
export { default as MonitorSmartphone } from './icons/monitor-smartphone.js';
export { default as MonitorSpeaker } from './icons/monitor-speaker.js';
export { default as MonitorStop } from './icons/monitor-stop.js';
export { default as MonitorUp } from './icons/monitor-up.js';
export { default as MonitorX } from './icons/monitor-x.js';
export { default as Monitor } from './icons/monitor.js';
export { default as MoonStar } from './icons/moon-star.js';
export { default as Moon } from './icons/moon.js';
export { default as MountainSnow } from './icons/mountain-snow.js';
export { default as Mountain } from './icons/mountain.js';
export { default as MousePointer2 } from './icons/mouse-pointer-2.js';
export { default as MousePointerClick } from './icons/mouse-pointer-click.js';
export { default as MousePointer } from './icons/mouse-pointer.js';
export { default as Mouse } from './icons/mouse.js';
export { default as Move3d } from './icons/move-3d.js';
export { default as MoveDiagonal2 } from './icons/move-diagonal-2.js';
export { default as MoveDiagonal } from './icons/move-diagonal.js';
export { default as MoveDownLeft } from './icons/move-down-left.js';
export { default as MoveDownRight } from './icons/move-down-right.js';
export { default as MoveDown } from './icons/move-down.js';
export { default as MoveHorizontal } from './icons/move-horizontal.js';
export { default as MoveLeft } from './icons/move-left.js';
export { default as MoveRight } from './icons/move-right.js';
export { default as MoveUpLeft } from './icons/move-up-left.js';
export { default as MoveUpRight } from './icons/move-up-right.js';
export { default as MoveUp } from './icons/move-up.js';
export { default as MoveVertical } from './icons/move-vertical.js';
export { default as Move } from './icons/move.js';
export { default as Music2 } from './icons/music-2.js';
export { default as Music3 } from './icons/music-3.js';
export { default as Music4 } from './icons/music-4.js';
export { default as Music } from './icons/music.js';
export { default as Navigation2Off } from './icons/navigation-2-off.js';
export { default as Navigation2 } from './icons/navigation-2.js';
export { default as NavigationOff } from './icons/navigation-off.js';
export { default as Navigation } from './icons/navigation.js';
export { default as Network } from './icons/network.js';
export { default as Newspaper } from './icons/newspaper.js';
export { default as Nfc } from './icons/nfc.js';
export { default as NotebookPen } from './icons/notebook-pen.js';
export { default as NotebookTabs } from './icons/notebook-tabs.js';
export { default as NotebookText } from './icons/notebook-text.js';
export { default as Notebook } from './icons/notebook.js';
export { default as NotepadTextDashed } from './icons/notepad-text-dashed.js';
export { default as NotepadText } from './icons/notepad-text.js';
export { default as NutOff } from './icons/nut-off.js';
export { default as Nut } from './icons/nut.js';
export { default as OctagonAlert } from './icons/octagon-alert.js';
export { default as OctagonPause } from './icons/octagon-pause.js';
export { default as OctagonX } from './icons/octagon-x.js';
export { default as Octagon } from './icons/octagon.js';
export { default as Option } from './icons/option.js';
export { default as Orbit } from './icons/orbit.js';
export { default as Package2 } from './icons/package-2.js';
export { default as PackageCheck } from './icons/package-check.js';
export { default as PackageMinus } from './icons/package-minus.js';
export { default as PackageOpen } from './icons/package-open.js';
export { default as PackagePlus } from './icons/package-plus.js';
export { default as PackageSearch } from './icons/package-search.js';
export { default as PackageX } from './icons/package-x.js';
export { default as Package } from './icons/package.js';
export { default as PaintBucket } from './icons/paint-bucket.js';
export { default as PaintRoller } from './icons/paint-roller.js';
export { default as Paintbrush2 } from './icons/paintbrush-2.js';
export { default as Paintbrush } from './icons/paintbrush.js';
export { default as Palette } from './icons/palette.js';
export { default as PanelBottomClose } from './icons/panel-bottom-close.js';
export { default as PanelBottomDashed } from './icons/panel-bottom-dashed.js';
export { default as PanelBottomOpen } from './icons/panel-bottom-open.js';
export { default as PanelBottom } from './icons/panel-bottom.js';
export { default as PanelLeftClose } from './icons/panel-left-close.js';
export { default as PanelLeftDashed } from './icons/panel-left-dashed.js';
export { default as PanelLeftOpen } from './icons/panel-left-open.js';
export { default as PanelLeft } from './icons/panel-left.js';
export { default as PanelRightClose } from './icons/panel-right-close.js';
export { default as PanelRightDashed } from './icons/panel-right-dashed.js';
export { default as PanelRightOpen } from './icons/panel-right-open.js';
export { default as PanelRight } from './icons/panel-right.js';
export { default as PanelTopClose } from './icons/panel-top-close.js';
export { default as PanelTopDashed } from './icons/panel-top-dashed.js';
export { default as PanelTopOpen } from './icons/panel-top-open.js';
export { default as PanelTop } from './icons/panel-top.js';
export { default as PanelsLeftBottom } from './icons/panels-left-bottom.js';
export { default as PanelsRightBottom } from './icons/panels-right-bottom.js';
export { default as PanelsTopLeft } from './icons/panels-top-left.js';
export { default as Paperclip } from './icons/paperclip.js';
export { default as Parentheses } from './icons/parentheses.js';
export { default as ParkingMeter } from './icons/parking-meter.js';
export { default as PartyPopper } from './icons/party-popper.js';
export { default as Pause } from './icons/pause.js';
export { default as PawPrint } from './icons/paw-print.js';
export { default as PcCase } from './icons/pc-case.js';
export { default as PenLine } from './icons/pen-line.js';
export { default as PenTool } from './icons/pen-tool.js';
export { default as Pen } from './icons/pen.js';
export { default as PencilLine } from './icons/pencil-line.js';
export { default as PencilRuler } from './icons/pencil-ruler.js';
export { default as Pencil } from './icons/pencil.js';
export { default as Pentagon } from './icons/pentagon.js';
export { default as Percent } from './icons/percent.js';
export { default as PersonStanding } from './icons/person-standing.js';
export { default as PhoneCall } from './icons/phone-call.js';
export { default as PhoneForwarded } from './icons/phone-forwarded.js';
export { default as PhoneIncoming } from './icons/phone-incoming.js';
export { default as PhoneMissed } from './icons/phone-missed.js';
export { default as PhoneOff } from './icons/phone-off.js';
export { default as PhoneOutgoing } from './icons/phone-outgoing.js';
export { default as Phone } from './icons/phone.js';
export { default as Pi } from './icons/pi.js';
export { default as Piano } from './icons/piano.js';
export { default as Pickaxe } from './icons/pickaxe.js';
export { default as PictureInPicture2 } from './icons/picture-in-picture-2.js';
export { default as PictureInPicture } from './icons/picture-in-picture.js';
export { default as PieChart } from './icons/pie-chart.js';
export { default as PiggyBank } from './icons/piggy-bank.js';
export { default as Pilcrow } from './icons/pilcrow.js';
export { default as Pill } from './icons/pill.js';
export { default as PinOff } from './icons/pin-off.js';
export { default as Pin } from './icons/pin.js';
export { default as Pipette } from './icons/pipette.js';
export { default as Pizza } from './icons/pizza.js';
export { default as PlaneLanding } from './icons/plane-landing.js';
export { default as PlaneTakeoff } from './icons/plane-takeoff.js';
export { default as Plane } from './icons/plane.js';
export { default as Play } from './icons/play.js';
export { default as Plug2 } from './icons/plug-2.js';
export { default as PlugZap2 } from './icons/plug-zap-2.js';
export { default as PlugZap } from './icons/plug-zap.js';
export { default as Plug } from './icons/plug.js';
export { default as Plus } from './icons/plus.js';
export { default as PocketKnife } from './icons/pocket-knife.js';
export { default as Pocket } from './icons/pocket.js';
export { default as Podcast } from './icons/podcast.js';
export { default as PointerOff } from './icons/pointer-off.js';
export { default as Pointer } from './icons/pointer.js';
export { default as Popcorn } from './icons/popcorn.js';
export { default as Popsicle } from './icons/popsicle.js';
export { default as PoundSterling } from './icons/pound-sterling.js';
export { default as PowerOff } from './icons/power-off.js';
export { default as Power } from './icons/power.js';
export { default as Presentation } from './icons/presentation.js';
export { default as Printer } from './icons/printer.js';
export { default as Projector } from './icons/projector.js';
export { default as Proportions } from './icons/proportions.js';
export { default as Puzzle } from './icons/puzzle.js';
export { default as Pyramid } from './icons/pyramid.js';
export { default as QrCode } from './icons/qr-code.js';
export { default as Quote } from './icons/quote.js';
export { default as Rabbit } from './icons/rabbit.js';
export { default as Radar } from './icons/radar.js';
export { default as Radiation } from './icons/radiation.js';
export { default as Radical } from './icons/radical.js';
export { default as RadioReceiver } from './icons/radio-receiver.js';
export { default as RadioTower } from './icons/radio-tower.js';
export { default as Radio } from './icons/radio.js';
export { default as Radius } from './icons/radius.js';
export { default as RailSymbol } from './icons/rail-symbol.js';
export { default as Rainbow } from './icons/rainbow.js';
export { default as Rat } from './icons/rat.js';
export { default as Ratio } from './icons/ratio.js';
export { default as ReceiptCent } from './icons/receipt-cent.js';
export { default as ReceiptEuro } from './icons/receipt-euro.js';
export { default as ReceiptIndianRupee } from './icons/receipt-indian-rupee.js';
export { default as ReceiptJapaneseYen } from './icons/receipt-japanese-yen.js';
export { default as ReceiptPoundSterling } from './icons/receipt-pound-sterling.js';
export { default as ReceiptRussianRuble } from './icons/receipt-russian-ruble.js';
export { default as ReceiptSwissFranc } from './icons/receipt-swiss-franc.js';
export { default as ReceiptText } from './icons/receipt-text.js';
export { default as Receipt } from './icons/receipt.js';
export { default as RectangleEllipsis } from './icons/rectangle-ellipsis.js';
export { default as RectangleHorizontal } from './icons/rectangle-horizontal.js';
export { default as RectangleVertical } from './icons/rectangle-vertical.js';
export { default as Recycle } from './icons/recycle.js';
export { default as Redo2 } from './icons/redo-2.js';
export { default as RedoDot } from './icons/redo-dot.js';
export { default as Redo } from './icons/redo.js';
export { default as RefreshCcwDot } from './icons/refresh-ccw-dot.js';
export { default as RefreshCcw } from './icons/refresh-ccw.js';
export { default as RefreshCwOff } from './icons/refresh-cw-off.js';
export { default as RefreshCw } from './icons/refresh-cw.js';
export { default as Refrigerator } from './icons/refrigerator.js';
export { default as Regex } from './icons/regex.js';
export { default as RemoveFormatting } from './icons/remove-formatting.js';
export { default as Repeat1 } from './icons/repeat-1.js';
export { default as Repeat2 } from './icons/repeat-2.js';
export { default as Repeat } from './icons/repeat.js';
export { default as ReplaceAll } from './icons/replace-all.js';
export { default as Replace } from './icons/replace.js';
export { default as ReplyAll } from './icons/reply-all.js';
export { default as Reply } from './icons/reply.js';
export { default as Rewind } from './icons/rewind.js';
export { default as Ribbon } from './icons/ribbon.js';
export { default as Rocket } from './icons/rocket.js';
export { default as RockingChair } from './icons/rocking-chair.js';
export { default as RollerCoaster } from './icons/roller-coaster.js';
export { default as Rotate3d } from './icons/rotate-3d.js';
export { default as RotateCcwSquare } from './icons/rotate-ccw-square.js';
export { default as RotateCcw } from './icons/rotate-ccw.js';
export { default as RotateCwSquare } from './icons/rotate-cw-square.js';
export { default as RotateCw } from './icons/rotate-cw.js';
export { default as RouteOff } from './icons/route-off.js';
export { default as Route } from './icons/route.js';
export { default as Router } from './icons/router.js';
export { default as Rows2 } from './icons/rows-2.js';
export { default as Rows3 } from './icons/rows-3.js';
export { default as Rows4 } from './icons/rows-4.js';
export { default as Rss } from './icons/rss.js';
export { default as Ruler } from './icons/ruler.js';
export { default as RussianRuble } from './icons/russian-ruble.js';
export { default as Sailboat } from './icons/sailboat.js';
export { default as Salad } from './icons/salad.js';
export { default as Sandwich } from './icons/sandwich.js';
export { default as SatelliteDish } from './icons/satellite-dish.js';
export { default as Satellite } from './icons/satellite.js';
export { default as SaveAll } from './icons/save-all.js';
export { default as Save } from './icons/save.js';
export { default as Scale3d } from './icons/scale-3d.js';
export { default as Scale } from './icons/scale.js';
export { default as Scaling } from './icons/scaling.js';
export { default as ScanBarcode } from './icons/scan-barcode.js';
export { default as ScanEye } from './icons/scan-eye.js';
export { default as ScanFace } from './icons/scan-face.js';
export { default as ScanLine } from './icons/scan-line.js';
export { default as ScanSearch } from './icons/scan-search.js';
export { default as ScanText } from './icons/scan-text.js';
export { default as Scan } from './icons/scan.js';
export { default as ScatterChart } from './icons/scatter-chart.js';
export { default as School } from './icons/school.js';
export { default as ScissorsLineDashed } from './icons/scissors-line-dashed.js';
export { default as Scissors } from './icons/scissors.js';
export { default as ScreenShareOff } from './icons/screen-share-off.js';
export { default as ScreenShare } from './icons/screen-share.js';
export { default as ScrollText } from './icons/scroll-text.js';
export { default as Scroll } from './icons/scroll.js';
export { default as SearchCheck } from './icons/search-check.js';
export { default as SearchCode } from './icons/search-code.js';
export { default as SearchSlash } from './icons/search-slash.js';
export { default as SearchX } from './icons/search-x.js';
export { default as Search } from './icons/search.js';
export { default as SendHorizontal } from './icons/send-horizontal.js';
export { default as SendToBack } from './icons/send-to-back.js';
export { default as Send } from './icons/send.js';
export { default as SeparatorHorizontal } from './icons/separator-horizontal.js';
export { default as SeparatorVertical } from './icons/separator-vertical.js';
export { default as ServerCog } from './icons/server-cog.js';
export { default as ServerCrash } from './icons/server-crash.js';
export { default as ServerOff } from './icons/server-off.js';
export { default as Server } from './icons/server.js';
export { default as Settings2 } from './icons/settings-2.js';
export { default as Settings } from './icons/settings.js';
export { default as Shapes } from './icons/shapes.js';
export { default as Share2 } from './icons/share-2.js';
export { default as Share } from './icons/share.js';
export { default as Sheet } from './icons/sheet.js';
export { default as Shell } from './icons/shell.js';
export { default as ShieldAlert } from './icons/shield-alert.js';
export { default as ShieldBan } from './icons/shield-ban.js';
export { default as ShieldCheck } from './icons/shield-check.js';
export { default as ShieldEllipsis } from './icons/shield-ellipsis.js';
export { default as ShieldHalf } from './icons/shield-half.js';
export { default as ShieldMinus } from './icons/shield-minus.js';
export { default as ShieldOff } from './icons/shield-off.js';
export { default as ShieldPlus } from './icons/shield-plus.js';
export { default as ShieldQuestion } from './icons/shield-question.js';
export { default as ShieldX } from './icons/shield-x.js';
export { default as Shield } from './icons/shield.js';
export { default as ShipWheel } from './icons/ship-wheel.js';
export { default as Ship } from './icons/ship.js';
export { default as Shirt } from './icons/shirt.js';
export { default as ShoppingBag } from './icons/shopping-bag.js';
export { default as ShoppingBasket } from './icons/shopping-basket.js';
export { default as ShoppingCart } from './icons/shopping-cart.js';
export { default as Shovel } from './icons/shovel.js';
export { default as ShowerHead } from './icons/shower-head.js';
export { default as Shrink } from './icons/shrink.js';
export { default as Shrub } from './icons/shrub.js';
export { default as Shuffle } from './icons/shuffle.js';
export { default as Sigma } from './icons/sigma.js';
export { default as SignalHigh } from './icons/signal-high.js';
export { default as SignalLow } from './icons/signal-low.js';
export { default as SignalMedium } from './icons/signal-medium.js';
export { default as SignalZero } from './icons/signal-zero.js';
export { default as Signal } from './icons/signal.js';
export { default as SignpostBig } from './icons/signpost-big.js';
export { default as Signpost } from './icons/signpost.js';
export { default as Siren } from './icons/siren.js';
export { default as SkipBack } from './icons/skip-back.js';
export { default as SkipForward } from './icons/skip-forward.js';
export { default as Skull } from './icons/skull.js';
export { default as Slack } from './icons/slack.js';
export { default as Slash } from './icons/slash.js';
export { default as Slice } from './icons/slice.js';
export { default as SlidersHorizontal } from './icons/sliders-horizontal.js';
export { default as SlidersVertical } from './icons/sliders-vertical.js';
export { default as SmartphoneCharging } from './icons/smartphone-charging.js';
export { default as SmartphoneNfc } from './icons/smartphone-nfc.js';
export { default as Smartphone } from './icons/smartphone.js';
export { default as SmilePlus } from './icons/smile-plus.js';
export { default as Smile } from './icons/smile.js';
export { default as Snail } from './icons/snail.js';
export { default as Snowflake } from './icons/snowflake.js';
export { default as Sofa } from './icons/sofa.js';
export { default as Soup } from './icons/soup.js';
export { default as Space } from './icons/space.js';
export { default as Spade } from './icons/spade.js';
export { default as Sparkle } from './icons/sparkle.js';
export { default as Sparkles } from './icons/sparkles.js';
export { default as Speaker } from './icons/speaker.js';
export { default as Speech } from './icons/speech.js';
export { default as SpellCheck2 } from './icons/spell-check-2.js';
export { default as SpellCheck } from './icons/spell-check.js';
export { default as Spline } from './icons/spline.js';
export { default as Split } from './icons/split.js';
export { default as SprayCan } from './icons/spray-can.js';
export { default as Sprout } from './icons/sprout.js';
export { default as SquareActivity } from './icons/square-activity.js';
export { default as SquareArrowDownLeft } from './icons/square-arrow-down-left.js';
export { default as SquareArrowDownRight } from './icons/square-arrow-down-right.js';
export { default as SquareArrowDown } from './icons/square-arrow-down.js';
export { default as SquareArrowLeft } from './icons/square-arrow-left.js';
export { default as SquareArrowOutDownLeft } from './icons/square-arrow-out-down-left.js';
export { default as SquareArrowOutDownRight } from './icons/square-arrow-out-down-right.js';
export { default as SquareArrowOutUpLeft } from './icons/square-arrow-out-up-left.js';
export { default as SquareArrowOutUpRight } from './icons/square-arrow-out-up-right.js';
export { default as SquareArrowRight } from './icons/square-arrow-right.js';
export { default as SquareArrowUpLeft } from './icons/square-arrow-up-left.js';
export { default as SquareArrowUpRight } from './icons/square-arrow-up-right.js';
export { default as SquareArrowUp } from './icons/square-arrow-up.js';
export { default as SquareAsterisk } from './icons/square-asterisk.js';
export { default as SquareBottomDashedScissors } from './icons/square-bottom-dashed-scissors.js';
export { default as SquareCheckBig } from './icons/square-check-big.js';
export { default as SquareCheck } from './icons/square-check.js';
export { default as SquareChevronDown } from './icons/square-chevron-down.js';
export { default as SquareChevronLeft } from './icons/square-chevron-left.js';
export { default as SquareChevronRight } from './icons/square-chevron-right.js';
export { default as SquareChevronUp } from './icons/square-chevron-up.js';
export { default as SquareCode } from './icons/square-code.js';
export { default as SquareDashedBottomCode } from './icons/square-dashed-bottom-code.js';
export { default as SquareDashedBottom } from './icons/square-dashed-bottom.js';
export { default as SquareDashedKanban } from './icons/square-dashed-kanban.js';
export { default as SquareDashedMousePointer } from './icons/square-dashed-mouse-pointer.js';
export { default as SquareDivide } from './icons/square-divide.js';
export { default as SquareDot } from './icons/square-dot.js';
export { default as SquareEqual } from './icons/square-equal.js';
export { default as SquareFunction } from './icons/square-function.js';
export { default as SquareGanttChart } from './icons/square-gantt-chart.js';
export { default as SquareKanban } from './icons/square-kanban.js';
export { default as SquareLibrary } from './icons/square-library.js';
export { default as SquareM } from './icons/square-m.js';
export { default as SquareMenu } from './icons/square-menu.js';
export { default as SquareMinus } from './icons/square-minus.js';
export { default as SquareMousePointer } from './icons/square-mouse-pointer.js';
export { default as SquareParkingOff } from './icons/square-parking-off.js';
export { default as SquareParking } from './icons/square-parking.js';
export { default as SquarePen } from './icons/square-pen.js';
export { default as SquarePercent } from './icons/square-percent.js';
export { default as SquarePi } from './icons/square-pi.js';
export { default as SquarePilcrow } from './icons/square-pilcrow.js';
export { default as SquarePlay } from './icons/square-play.js';
export { default as SquarePlus } from './icons/square-plus.js';
export { default as SquarePower } from './icons/square-power.js';
export { default as SquareRadical } from './icons/square-radical.js';
export { default as SquareScissors } from './icons/square-scissors.js';
export { default as SquareSigma } from './icons/square-sigma.js';
export { default as SquareSlash } from './icons/square-slash.js';
export { default as SquareSplitHorizontal } from './icons/square-split-horizontal.js';
export { default as SquareSplitVertical } from './icons/square-split-vertical.js';
export { default as SquareStack } from './icons/square-stack.js';
export { default as SquareTerminal } from './icons/square-terminal.js';
export { default as SquareUserRound } from './icons/square-user-round.js';
export { default as SquareUser } from './icons/square-user.js';
export { default as SquareX } from './icons/square-x.js';
export { default as Square } from './icons/square.js';
export { default as Squircle } from './icons/squircle.js';
export { default as Squirrel } from './icons/squirrel.js';
export { default as Stamp } from './icons/stamp.js';
export { default as StarHalf } from './icons/star-half.js';
export { default as StarOff } from './icons/star-off.js';
export { default as Star } from './icons/star.js';
export { default as StepBack } from './icons/step-back.js';
export { default as StepForward } from './icons/step-forward.js';
export { default as Stethoscope } from './icons/stethoscope.js';
export { default as Sticker } from './icons/sticker.js';
export { default as StickyNote } from './icons/sticky-note.js';
export { default as Store } from './icons/store.js';
export { default as StretchHorizontal } from './icons/stretch-horizontal.js';
export { default as StretchVertical } from './icons/stretch-vertical.js';
export { default as Strikethrough } from './icons/strikethrough.js';
export { default as Subscript } from './icons/subscript.js';
export { default as SunDim } from './icons/sun-dim.js';
export { default as SunMedium } from './icons/sun-medium.js';
export { default as SunMoon } from './icons/sun-moon.js';
export { default as SunSnow } from './icons/sun-snow.js';
export { default as Sun } from './icons/sun.js';
export { default as Sunrise } from './icons/sunrise.js';
export { default as Sunset } from './icons/sunset.js';
export { default as Superscript } from './icons/superscript.js';
export { default as SwatchBook } from './icons/swatch-book.js';
export { default as SwissFranc } from './icons/swiss-franc.js';
export { default as SwitchCamera } from './icons/switch-camera.js';
export { default as Sword } from './icons/sword.js';
export { default as Swords } from './icons/swords.js';
export { default as Syringe } from './icons/syringe.js';
export { default as Table2 } from './icons/table-2.js';
export { default as TableCellsMerge } from './icons/table-cells-merge.js';
export { default as TableCellsSplit } from './icons/table-cells-split.js';
export { default as TableColumnsSplit } from './icons/table-columns-split.js';
export { default as TableProperties } from './icons/table-properties.js';
export { default as TableRowsSplit } from './icons/table-rows-split.js';
export { default as Table } from './icons/table.js';
export { default as TabletSmartphone } from './icons/tablet-smartphone.js';
export { default as Tablet } from './icons/tablet.js';
export { default as Tablets } from './icons/tablets.js';
export { default as Tag } from './icons/tag.js';
export { default as Tags } from './icons/tags.js';
export { default as Tally1 } from './icons/tally-1.js';
export { default as Tally2 } from './icons/tally-2.js';
export { default as Tally3 } from './icons/tally-3.js';
export { default as Tally4 } from './icons/tally-4.js';
export { default as Tally5 } from './icons/tally-5.js';
export { default as Tangent } from './icons/tangent.js';
export { default as Target } from './icons/target.js';
export { default as Telescope } from './icons/telescope.js';
export { default as TentTree } from './icons/tent-tree.js';
export { default as Tent } from './icons/tent.js';
export { default as Terminal } from './icons/terminal.js';
export { default as TestTubeDiagonal } from './icons/test-tube-diagonal.js';
export { default as TestTube } from './icons/test-tube.js';
export { default as TestTubes } from './icons/test-tubes.js';
export { default as TextCursorInput } from './icons/text-cursor-input.js';
export { default as TextCursor } from './icons/text-cursor.js';
export { default as TextQuote } from './icons/text-quote.js';
export { default as TextSearch } from './icons/text-search.js';
export { default as TextSelect } from './icons/text-select.js';
export { default as Text } from './icons/text.js';
export { default as Theater } from './icons/theater.js';
export { default as ThermometerSnowflake } from './icons/thermometer-snowflake.js';
export { default as ThermometerSun } from './icons/thermometer-sun.js';
export { default as Thermometer } from './icons/thermometer.js';
export { default as ThumbsDown } from './icons/thumbs-down.js';
export { default as ThumbsUp } from './icons/thumbs-up.js';
export { default as TicketCheck } from './icons/ticket-check.js';
export { default as TicketMinus } from './icons/ticket-minus.js';
export { default as TicketPercent } from './icons/ticket-percent.js';
export { default as TicketPlus } from './icons/ticket-plus.js';
export { default as TicketSlash } from './icons/ticket-slash.js';
export { default as TicketX } from './icons/ticket-x.js';
export { default as Ticket } from './icons/ticket.js';
export { default as TimerOff } from './icons/timer-off.js';
export { default as TimerReset } from './icons/timer-reset.js';
export { default as Timer } from './icons/timer.js';
export { default as ToggleLeft } from './icons/toggle-left.js';
export { default as ToggleRight } from './icons/toggle-right.js';
export { default as Tornado } from './icons/tornado.js';
export { default as Torus } from './icons/torus.js';
export { default as TouchpadOff } from './icons/touchpad-off.js';
export { default as Touchpad } from './icons/touchpad.js';
export { default as TowerControl } from './icons/tower-control.js';
export { default as ToyBrick } from './icons/toy-brick.js';
export { default as Tractor } from './icons/tractor.js';
export { default as TrafficCone } from './icons/traffic-cone.js';
export { default as TrainFrontTunnel } from './icons/train-front-tunnel.js';
export { default as TrainFront } from './icons/train-front.js';
export { default as TrainTrack } from './icons/train-track.js';
export { default as TramFront } from './icons/tram-front.js';
export { default as Trash2 } from './icons/trash-2.js';
export { default as Trash } from './icons/trash.js';
export { default as TreeDeciduous } from './icons/tree-deciduous.js';
export { default as TreePalm } from './icons/tree-palm.js';
export { default as TreePine } from './icons/tree-pine.js';
export { default as Trees } from './icons/trees.js';
export { default as Trello } from './icons/trello.js';
export { default as TrendingDown } from './icons/trending-down.js';
export { default as TrendingUp } from './icons/trending-up.js';
export { default as TriangleAlert } from './icons/triangle-alert.js';
export { default as TriangleRight } from './icons/triangle-right.js';
export { default as Triangle } from './icons/triangle.js';
export { default as Trophy } from './icons/trophy.js';
export { default as Truck } from './icons/truck.js';
export { default as Turtle } from './icons/turtle.js';
export { default as Tv2 } from './icons/tv-2.js';
export { default as Tv } from './icons/tv.js';
export { default as Twitch } from './icons/twitch.js';
export { default as Twitter } from './icons/twitter.js';
export { default as Type } from './icons/type.js';
export { default as UmbrellaOff } from './icons/umbrella-off.js';
export { default as Umbrella } from './icons/umbrella.js';
export { default as Underline } from './icons/underline.js';
export { default as Undo2 } from './icons/undo-2.js';
export { default as UndoDot } from './icons/undo-dot.js';
export { default as Undo } from './icons/undo.js';
export { default as UnfoldHorizontal } from './icons/unfold-horizontal.js';
export { default as UnfoldVertical } from './icons/unfold-vertical.js';
export { default as Ungroup } from './icons/ungroup.js';
export { default as University } from './icons/university.js';
export { default as Unlink2 } from './icons/unlink-2.js';
export { default as Unlink } from './icons/unlink.js';
export { default as Unplug } from './icons/unplug.js';
export { default as Upload } from './icons/upload.js';
export { default as Usb } from './icons/usb.js';
export { default as UserCheck } from './icons/user-check.js';
export { default as UserCog } from './icons/user-cog.js';
export { default as UserMinus } from './icons/user-minus.js';
export { default as UserPlus } from './icons/user-plus.js';
export { default as UserRoundCheck } from './icons/user-round-check.js';
export { default as UserRoundCog } from './icons/user-round-cog.js';
export { default as UserRoundMinus } from './icons/user-round-minus.js';
export { default as UserRoundPlus } from './icons/user-round-plus.js';
export { default as UserRoundSearch } from './icons/user-round-search.js';
export { default as UserRoundX } from './icons/user-round-x.js';
export { default as UserRound } from './icons/user-round.js';
export { default as UserSearch } from './icons/user-search.js';
export { default as UserX } from './icons/user-x.js';
export { default as User } from './icons/user.js';
export { default as UsersRound } from './icons/users-round.js';
export { default as Users } from './icons/users.js';
export { default as UtensilsCrossed } from './icons/utensils-crossed.js';
export { default as Utensils } from './icons/utensils.js';
export { default as UtilityPole } from './icons/utility-pole.js';
export { default as Variable } from './icons/variable.js';
export { default as Vault } from './icons/vault.js';
export { default as Vegan } from './icons/vegan.js';
export { default as VenetianMask } from './icons/venetian-mask.js';
export { default as VibrateOff } from './icons/vibrate-off.js';
export { default as Vibrate } from './icons/vibrate.js';
export { default as VideoOff } from './icons/video-off.js';
export { default as Video } from './icons/video.js';
export { default as Videotape } from './icons/videotape.js';
export { default as View } from './icons/view.js';
export { default as Voicemail } from './icons/voicemail.js';
export { default as Volume1 } from './icons/volume-1.js';
export { default as Volume2 } from './icons/volume-2.js';
export { default as VolumeX } from './icons/volume-x.js';
export { default as Volume } from './icons/volume.js';
export { default as Vote } from './icons/vote.js';
export { default as WalletCards } from './icons/wallet-cards.js';
export { default as WalletMinimal } from './icons/wallet-minimal.js';
export { default as Wallet } from './icons/wallet.js';
export { default as Wallpaper } from './icons/wallpaper.js';
export { default as WandSparkles } from './icons/wand-sparkles.js';
export { default as Wand } from './icons/wand.js';
export { default as Warehouse } from './icons/warehouse.js';
export { default as WashingMachine } from './icons/washing-machine.js';
export { default as Watch } from './icons/watch.js';
export { default as Waves } from './icons/waves.js';
export { default as Waypoints } from './icons/waypoints.js';
export { default as Webcam } from './icons/webcam.js';
export { default as WebhookOff } from './icons/webhook-off.js';
export { default as Webhook } from './icons/webhook.js';
export { default as Weight } from './icons/weight.js';
export { default as WheatOff } from './icons/wheat-off.js';
export { default as Wheat } from './icons/wheat.js';
export { default as WholeWord } from './icons/whole-word.js';
export { default as WifiOff } from './icons/wifi-off.js';
export { default as Wifi } from './icons/wifi.js';
export { default as Wind } from './icons/wind.js';
export { default as WineOff } from './icons/wine-off.js';
export { default as Wine } from './icons/wine.js';
export { default as Workflow } from './icons/workflow.js';
export { default as WrapText } from './icons/wrap-text.js';
export { default as Wrench } from './icons/wrench.js';
export { default as X } from './icons/x.js';
export { default as Youtube } from './icons/youtube.js';
export { default as ZapOff } from './icons/zap-off.js';
export { default as Zap } from './icons/zap.js';
export { default as ZoomIn } from './icons/zoom-in.js';
export { default as ZoomOut } from './icons/zoom-out.js';

const createIcons = ({ icons = {}, nameAttr = "data-lucide", attrs = {} } = {}) => {
  if (!Object.values(icons).length) {
    throw new Error(
      "Please provide an icons object.\nIf you want to use all the icons you can import it like:\n `import { createIcons, icons } from 'lucide';\nlucide.createIcons({icons});`"
    );
  }
  if (typeof document === "undefined") {
    throw new Error("`createIcons()` only works in a browser environment.");
  }
  const elementsToReplace = document.querySelectorAll(`[${nameAttr}]`);
  Array.from(elementsToReplace).forEach(
    (element) => replaceElement(element, { nameAttr, icons, attrs })
  );
  if (nameAttr === "data-lucide") {
    const deprecatedElements = document.querySelectorAll("[icon-name]");
    if (deprecatedElements.length > 0) {
      console.warn(
        "[Lucide] Some icons were found with the now deprecated icon-name attribute. These will still be replaced for backwards compatibility, but will no longer be supported in v1.0 and you should switch to data-lucide"
      );
      Array.from(deprecatedElements).forEach(
        (element) => replaceElement(element, { nameAttr: "icon-name", icons, attrs })
      );
    }
  }
};

export { createIcons };
//# sourceMappingURL=lucide.js.map
